<template>
  <f7-fab
    class="geo-btn"
    position="right-top"
    :color="geoActive && follow ? 'blue' : dark ? 'black' : 'white'"
    @click="click">
    <div
      class="geo-loading"
      v-if="geoLoading">
      <f7-preloader
        color="blue"
        :size="24" />
    </div>
    <FlatIcon
      v-else
      :name="geoActive && follow ? 'geo-white' : 'geo'"
      :size="32" />
  </f7-fab>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'GeoBtn',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      geoPos: 'global/geoPos',
      geoActive: 'global/geoActive',
      geoLoading: 'global/geoLoading'
    }),
    follow () {
      return this.setting('follow')
    }
  },
  methods: {
    ...mapActions({
      geoStart: 'global/geoStart',
      setSetting: 'global/setSetting',
      setFlyTo: 'global/setFlyTo'
    }),
    click () {
      if (this.geoActive) {
        this.setFlyTo(this.geoPos)
        this.setSetting({ follow: true })
      } else {
        this.geoStart().then(res => {
          this.setFlyTo([res.latitude, res.longitude])
        })
      }
    }
  }
}
</script>

<style lang="scss">
.geo-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
</style>
